import "isomorphic-fetch";
import { Aurelia, PLATFORM } from "aurelia-framework";
import { HttpClient } from "aurelia-fetch-client";
import ServiceConfig from 'shared/config/service-config';
import authConfig from 'shared/config/auth-config';
import * as entities from "data/entities/entities";
import 'assets/css/index.css';
import "bootstrap/dist/css/bootstrap.css";
import "syncfusion-javascript/Content/ej/web/bootstrap-theme/ej.web.all.min.css";
import "bootstrap";
import * as Bluebird from 'bluebird';
//The wForgottenReturn:false removes a warning that will be thrown by Aurelia when configuring during startup.
Bluebird.config({ warnings: { wForgottenReturn: false } });
import 'whatwg-fetch';
import 'core/extensions';
declare const IS_DEV_BUILD: boolean; // The value is supplied by Webpack during the build

//Export jQuery to window object
import * as $ from 'jquery';

export function configure(aurelia: Aurelia) {

	console.log('isDevBuild=' + IS_DEV_BUILD);

	let winObj: any = <any>window;
	winObj['jQuery'] = $;
	winObj['$'] = $;
	console.log("JQuery init");

	aurelia.use.standardConfiguration()
		.globalResources(
			[
				PLATFORM.moduleName('core/converters/date-format'),
				PLATFORM.moduleName('core/converters/authorized-value-converter'),
				PLATFORM.moduleName('core/converters/id-to-name-value-converter'),
				PLATFORM.moduleName('core/converters/is-in-role-value-converter'),
				PLATFORM.moduleName('core/converters/percentage-format'),
				PLATFORM.moduleName('core/converters/date-time-difference'),
				PLATFORM.moduleName('core/converters/date-time-format'),
				PLATFORM.moduleName('core/converters/currency-format'),
				PLATFORM.moduleName('core/converters/filter-on-property'),
				PLATFORM.moduleName('shared/elements/widget/widget'),
				PLATFORM.moduleName('shared/elements/help-widget/help-widget'),
				PLATFORM.moduleName('shared/elements/help-widget/help-icon'),
				PLATFORM.moduleName('shared/elements/property-widget/property-widget'),
				PLATFORM.moduleName('shared/elements/editable-widget/editable-widget')
			])

	if (IS_DEV_BUILD) {
		aurelia.use.developmentLogging();
	}

	new HttpClient().configure(config => {
		const baseUrl = document.getElementsByTagName("base")[0].href;
		config.withBaseUrl(baseUrl);
	});


	//register aurelia-syncfusion-bridge plugin here
	aurelia.use.plugin(PLATFORM.moduleName('aurelia-syncfusion-bridge'), plugin => plugin.useAll())
		//			ejButton()
		//		.ejAutocomplete()
		//		.ejGantt()
		//		.ejRadioButton()
		//		.ejSchedule()
		//		.ejDatePicker()
		//		.ejMenu()
		//		.ejRTE()
		//		.ejWaitingPopup()
		//		.ejUploadbox()
		//		.ejAccordion()
		//		.ejTab()
		//		.ejCheckBox()
		//		.ejSlider()
		//		.ejProgressBar()
		//		.ejDropDownList()
		//		.ejCurrencyTextbox()
		//		.ejComboBox()
		//		.ejNumericTextbox()
		//		.ejSplitter()
		//		.ejGrid()
		//		.ejChart()
		//		.ejSeries()
		//		.ejTemplate()


		//)
		.plugin(PLATFORM.moduleName('aurelia-after-attached-plugin'))
		.plugin(PLATFORM.moduleName('aurelia-dialog'))


		.plugin(PLATFORM.moduleName('aurelia-validation'))
		//.plugin(PLATFORM.moduleName("aurelia-validation/validate-binding-behavior"))
		//.plugin(PLATFORM.moduleName("aurelia-validation/validation-errors-custom-attribute"))
		//.plugin(PLATFORM.moduleName("aurelia-validation/validation-renderer-custom-attribute"))
		.plugin(PLATFORM.moduleName("aurelia-orm/component/association-select"))
		.plugin(PLATFORM.moduleName("aurelia-orm/component/paged"))

		.plugin(PLATFORM.moduleName('aurelia-orm'),
			builder => {
				builder.registerEntities(entities);
			})
		.plugin('aurelia-validation')
		.plugin(PLATFORM.moduleName('aurelia-api'),
			config => {
				config
					.registerEndpoint('protected-api', configure => {
						configure
							.withBaseUrl(ServiceConfig.serviceName)
							.withDefaults({
								headers: {
									'Accept': 'application/json',
									'Content-Type': 'application/json'
								},
								credentials: 'include'
							})
					})
					.registerEndpoint('auth', configure => {
						configure
							.withBaseUrl(ServiceConfig.serviceName)
							.withDefaults({
								headers: {
									'Accept': 'application/json',
									'Content-Type': 'application/json'
								},
								credentials: 'include'
							})
					})
					.setDefaultEndpoint('protected-api');



			})
		.plugin(PLATFORM.moduleName('aurelia-authentication'), baseConfig => {
			baseConfig.configure(authConfig);
		});


	//aurelia.start().then(() => aurelia.setRoot("app/components/app/app"));
	aurelia.start().then(() => aurelia.setRoot("app-shell"));
}
